var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99994 18.9994C2.46952 18.9994 1.96083 18.7887 1.58577 18.4137C1.21071 18.0386 1 17.5299 1 16.9995V1H9.99972L14.9996 5.99984V16.9995C14.9996 17.5299 14.7889 18.0386 14.4138 18.4137C14.0387 18.7887 13.53 18.9994 12.9996 18.9994H2.99994Z",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99878 1V6.99981H14.9986",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99927 11H10.9991M4.99927 14.9999H10.9991",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/PageIcon.a49626e21406705be5fbd06848381c51.svg";
export { ForwardRef as ReactComponent };